export function runJavascript(code: string): unknown {
    return eval(code);
}
